import {createSlice} from "@reduxjs/toolkit";
import {setUIProductionVolumeSearchFilter} from "./actions";
import {ProductionVolumeSearchCriteria} from "@ots-frontend/ots-data";

type ProductionVolumeUIState = {
  searchFilter?: ProductionVolumeSearchCriteria
}

const INITIAL_STATE: Readonly<ProductionVolumeUIState> = {};

const productionVolumeUISlice = createSlice({
  name: "ots-ui/production-volume",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIProductionVolumeSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const productionVolumeUIReducer = productionVolumeUISlice.reducer;
